export default __webpack_public_path__ + "static/media/default.32ce54712f2c97f40d605667d64a729e.png";